module.exports = __webpack_public_path__ + "img/thumbnail_ArcticWolf_m_normal.b07fafdf.png";